import { createContext, useState } from "react";
import SidebarMenuContext from "./sidebar-menu";

export const SettingsContext = createContext({}); 

export const SettingsProvider = (props) => {
    const { isMenuOpen, toggleMenu } = SidebarMenuContext();
    const [isLoading, setIsLoading] = useState(false);

    const handleLoading = (value) => {
        setTimeout(() => {
            setIsLoading(value);
          }, (!value) ? 700 : 0);
    };

    return (
        <SettingsContext.Provider
            value={{
                isMenuOpen,
                isLoading,
                toggleMenu,
                handleLoading
            }}
        >
            {props.children}
        </SettingsContext.Provider>
    );
};

export default SettingsProvider;